export default __webpack_public_path__ + "static/company-25fa295de44d501ff454dbbcd8d4badd.jpg";